import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";

export const getAllDocsByTask = async (taskId: string) => {
  try {
    const response = await apiClientSource.get(`/task-service/api/tasks/task/${taskId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los documentos de la tarea");
  }
}